<template>
  <div class="progress-bar">
    <span :style="style"/>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { setTimeout } from '@/utils/global';

  const DEFAULT_STYLE = {
    animationName: 'progress-bar',
    height: '100%',
  };

  const emit = defineEmits(['end']);

  const props = defineProps({
    animationDuration: {
      type: [String, Number],
      required: true,
    },
    backgroundColor: {
      type: String,
      default: 'black',
    },
  });

  const style = computed(() => Object.assign(DEFAULT_STYLE, {
    animationDuration: `${props.animationDuration}s`,
    backgroundColor: props.backgroundColor,
  }));

  setTimeout(() => {
    emit('end');
  }, props.animationDuration * 1000);
</script>
